<template lang='pug'>
tr(class='blue lighten-5')
  th(v-for="(header, idx) in headerProps.headers",
     :key="header.text",
     )
    v-text-field(v-if="header.rankingName" v-model="getNameidx(idx - 2).attributes.name" :label="header.text")
    template(v-else)
      | {{ header.text }}
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'AnalysisSetting',
  props: {
    headerProps: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
    }
  },

  computed: {
    ...mapGetters('ranking_preference', [
      'getNameidx',
    ]),
  },

  async created() {
  },

  methods: {
    ...mapActions('ranking_preference', [
    ]),
    ...mapMutations('ranking_preference', [
    ]),
  },
}
</script>

<style lang='scss' scoped>
</style>
